@if (isAcademyMode) {
<div class="academy-mode-banner">
  <strong>Academy Mode is ON.</strong>
  Data collected in this mode is only available in Academy Mode and will not
  appear in other modes.
</div>
}
@if (isIsdIopMode) {
<div class="isd-iop-mode-banner">
  <strong>ISD &amp; IOP Mode is ON.</strong>
  Data collected in this mode is only available in ISD &amp; IOP Mode and will not
  appear in other modes.
</div>
}
@if (isParentMode) {
<div class="parent-mode-banner">
  <strong>Parent Mode is ON.</strong>
  Data collected in this mode is only available in Parent Mode and will not
  appear in other modes.
</div>
}

<div class="light-load-banner" *ngIf="lightLoad.isEnabled()">
  Light Load is on — session data only. Instructions, notes, and BIP are skipped to save memory.
  <button type="button" class="light-load-banner-button" (click)="turnOffLightLoad()">Load full data</button>
</div>
<div *ngFor="let failure of offlineDataService.failedSessionSaves()" class="alert alert-danger mb-0" role="alert">
  Session #{{ failure.sessionID }} has changes that could not be saved on this device. Keep Spark open and retry saving in its original Spark mode.
  <button type="button" class="btn btn-outline-danger ms-2" [disabled]="isRetryingLocalSave" (click)="retryLocalSave(failure)">Retry saving</button>
</div>
<app-spark-header
  [title]="currentScreen === 'settings' ? '' : (selectedPatient?.FullName ?? '') + (patientSessionService.getPatientSession()?.ServiceID ? ' - Service #' + patientSessionService.getPatientSession()?.ServiceID : '')"
  [loggedInUsername]="loggedInUsername" [patients]="patientOptions" [selectedPatientID]="selectedPatient?.ID"
  [showPatientSelector]="!offlineDataService.isInOfflineMode()" [showSignOut]="!offlineDataService.isInOfflineMode()"
  [offlinePatientsActive]="currentScreen === 'offline'" [hasUpdateAvailable]="hasUpdateAvailable"
  [academyMode]="isAcademyMode" [isdIopMode]="isIsdIopMode" [parentMode]="isParentMode" [(openMenu)]="openMenu"
  (patientChanged)="changedPatient({value: $event})" (sendLogs)="sendLogs()"
  (offlinePatients)="openOfflinePatients()" (signOut)="signOut()">
  <ng-container header-status>      @if (currentScreen !== 'settings') {
      <div
        class="offline-status ms-2"
        *ngIf="
          selectedPatient?.ID && !this.offlineDataService.isInOfflineMode()
        "
      >
        <button
          pButton
          pRipple
          type="button"
          [icon]="isDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
          (click)="downloadPatientProfile()"
          class="p-button-rounded p-button-outlined p-button-info"
          [pTooltip]="getDownloadTooltip()"
          tooltipPosition="bottom"
          [loading]="isDownloading"
        ></button>
      </div>

      <div class="offline-status ms-2 gap-0 flex-column align-items-center">
        @if (areThereUnsyncedData) {
        <small class="text-danger" style="font-size: 16px; font-weight: 500">{{
          isSyncing ? "Syncing..." : "You have un-synced data"
        }}</small>
        } @if (lastDownloadDate) {
        <small class="text-muted"
          >Last downloaded: {{ lastDownloadDate | date : "short" }}</small
        >
        }
      </div>

      <div
        class="offline-status ms-2"
        *ngIf="areThereUnsyncedData"
      >
        <button
          pButton
          pRipple
          type="button"
          [icon]="isSyncing ? 'pi pi-spin pi-spinner' : 'pi pi-sync'"
          (click)="syncPatientData()"
          class="p-button-rounded p-button-outlined p-button-info bg-danger text-white"
          [pTooltip]="getSyncTooltip()"
          tooltipPosition="bottom"
          [loading]="isSyncing"
        ></button>
      </div>

      } @if ( this.offlineDataService.isInOfflineMode()) {
      <span class="text-danger">Offline</span>
      } @if (currentScreen === 'staff-preview') {
      <span class="text-danger">Preview</span>
      }
</ng-container>
  <ng-container menu-before-patient>      <button
        *ngIf="hasAcademyModePermission()"
        type="button"
        (click)="toggleAcademyMode()"
        class="academy-mode-toggle-button"
        [class.is-on]="isAcademyMode"
        style="width: 100%"
      >
        <span class="academy-mode-toggle-track" aria-hidden="true">
          <span class="academy-mode-toggle-thumb"></span>
        </span>
        <span class="academy-mode-toggle-label">Academy Mode</span>
        <span class="academy-mode-toggle-state">{{
          isAcademyMode ? "ON" : "OFF"
        }}</span>
      </button>
      <button
        *ngIf="hasIsdIopModePermission()"
        type="button"
        (click)="toggleIsdIopMode()"
        class="isd-iop-mode-toggle-button"
        [class.is-on]="isIsdIopMode"
        style="width: 100%"
      >
        <span class="academy-mode-toggle-track" aria-hidden="true">
          <span class="academy-mode-toggle-thumb"></span>
        </span>
        <span class="academy-mode-toggle-label">ISD &amp; IOP Mode</span>
        <span class="academy-mode-toggle-state">{{
          isIsdIopMode ? "ON" : "OFF"
        }}</span>
      </button>
      <button
        *ngIf="hasParentModePermission()"
        type="button"
        (click)="toggleParentMode()"
        class="parent-mode-toggle-button"
        [class.is-on]="isParentMode"
        style="width: 100%"
        id="parentModeToggleButton"
      >
        <span class="academy-mode-toggle-track" aria-hidden="true">
          <span class="academy-mode-toggle-thumb"></span>
        </span>
        <span class="academy-mode-toggle-label">Parent Mode</span>
        <span class="academy-mode-toggle-state">{{
          isParentMode ? "ON" : "OFF"
        }}</span>
      </button>
</ng-container>
  <ng-container menu-session-actions>
    @if (!offlineDataService.isInOfflineMode()) {
      <button
        id="myServicesButton"
        [routerLink]="['/select-patient']"
        [queryParams]="getAcademyModeQueryParams()"
        (click)="openMenu = false"
        [class.side-menu-button2]="currentScreen !== 'select-patient'"
        [class.updates-button]="currentScreen === 'select-patient'"
        style="width: 100%"
      >
        My Opto Services
      </button>
    }
    @if (!offlineDataService.isInOfflineMode()) {      <button
        *ngIf="showSessionSyncButton"
        id="sessionSyncButton"
        class="session-sync-button"
        [class.active]="sessionSyncRunning"
        [title]="sessionSyncRunning ? 'Stop 2:1 session sync' : 'Start 2:1 session sync'"
        (click)="sessionSyncToggle.emit()"
      >
        <i class="pi pi-link"></i>
        <span>{{ sessionSyncRunning ? 'Stop 2:1 session sync' : 'Start 2:1 session sync' }}</span>
      </button>
      <!-- Staff section - show if user has staff permissions -->
      <ng-container *ngIf="hasStaffPermission()">
        <button
          (click)="switchToStaff()"
          *ngIf="
            this.patientSessionService.getPatientSession()?.ID &&
            this.patientSessionService.getPatientSession()?.ID !== -1 &&
            this.patientSessionService.getPatientSession()?.StaffID ==
              this.loggedUserID
          "
          [class.side-menu-button2]="currentScreen !== 'staff-home'"
          [class.updates-button]="currentScreen === 'staff-home'"
          style="line-height: 16px; width: 100%"
        >
          Session<br />
          <small
            style="font-size: 12px"
            *ngIf="this.patientSessionService.getPatientSession()?.ServiceID"
            >Service #{{
              this.patientSessionService.getPatientSession()?.ServiceID
            }}</small
          >
        </button>

        <button
          (click)="switchToSessionList()"
          id="allSessionsButton"
          [class.side-menu-button2]="currentScreen !== 'staff-sessions'"
          [class.updates-button]="currentScreen === 'staff-sessions'"
          *ngIf="selectedPatient"
          style="width: 100%"
        >
          All Sessions
        </button>
      </ng-container>

      <!-- Supervisor section - show if user has supervisor permissions -->
      <button
        (click)="switchToSupervisor()"
        id="supervisorButton"
        [class.side-menu-button2]="currentScreen !== 'supervisor'"
        [class.updates-button]="currentScreen === 'supervisor'"
        style="width: 100%"
        *ngIf="selectedPatient && hasSupervisorPermission()"
      >
        Supervisor
      </button>

      <!-- Graphs section - show if user has graphs permissions -->
      <button
        id="graphsButton"
        *ngIf="selectedPatient && hasGraphsPermission()"
        style="width: 100%"
        [routerLink]="['/graphs', selectedPatient.ID]"
        [queryParams]="getAcademyModeQueryParams()"
        [class.side-menu-button2]="currentScreen !== 'graphs'"
        [class.updates-button]="currentScreen === 'graphs'"
      >
        Graphs
      </button>
}
  </ng-container>
  <ng-container menu-settings>      <button
        *ngIf="lightLoad.isEnabled()"
        (click)="turnOffLightLoad()"
        class="side-menu-button2"
        id="turnOffLightLoadButton"
        style="width: 100%"
      >
        Load full Spark data
      </button>

      @if (!this.offlineDataService.isInOfflineMode()) {
      <!-- Settings section - show if user has settings permissions -->
      <button
        [routerLink]="['/settings/prompt-codes']"
        [class.side-menu-button2]="currentScreen !== 'settings'"
        [class.updates-button]="currentScreen === 'settings'"
        id="settingsButton"
        style="width: 100%"
        *ngIf="hasSettingsPermission()"
      >
        General Settings
      </button>
      <button
        (click)="backToOpto()"
        class="side-menu-button2"
        id="backToOptoButton"
        style="width: 100%"
      >
        Back to Opto
      </button>
}
  </ng-container>
  <ng-container menu-app-actions>
    @if (!offlineDataService.isInOfflineMode()) {      <button
        *ngIf="isInstallable"
        (click)="installApp()"
        class="side-menu-button2 install-menu-button"
        id="installAppButton"
        style="width: 100%"
      >
        Install App
      </button>
      }
      <small class="update-status-label">Spark {{ appVersionService.getVersionRaw() }}</small>
      <div
        class="update-status-container"
        [class.update-status-compact]="!hasUpdateAvailable"
      >
        <button
          *ngIf="hasUpdateAvailable"
          (click)="updateApp()"
          class="side-menu-button2 update-menu-button"
          id="updateAppButton"
          style="width: 100%"
          [disabled]="appVersionService.isApplyingUpdate"
        >
          {{ appVersionService.isApplyingUpdate ? "Updating..." : (appVersionService.recoveryRequired ? "Repair Spark" : "Update App (Available)") }}
        </button>
        <small *ngIf="!hasUpdateAvailable" class="update-status-label">
          {{ appVersionService.status }}
        </small>
        <button type="button" class="side-menu-button2" [disabled]="appVersionService.isApplyingUpdate"
          (click)="appVersionService.checkForUpdate()">Check for updates</button>
      </div>
  </ng-container>
</app-spark-header>
